import { forwardRef } from "react";

import { cva, type VariantProps } from "class-variance-authority";

import { Button, type ButtonProps } from "../Button";
import { cn } from "../index";

const actionButtonVariants = cva("text-primary-white disabled:bg-primary-dark-gray disabled:text-primary-white", {
  variants: {
    variant: {
      primary: "bg-primary-blue",
      danger: "bg-primary-red",
      cancel: "p-0 rounded-none bg-transparent text-primary-dark-gray",
    },
    rounded: {
      false: "rounded-md px-3.5 py-2.5",
      true: "px-3.5 py-2.5 rounded-[50px]",
    },
  },
  defaultVariants: {
    variant: "primary",
    rounded: false,
  },
});

interface ActionButtonProps extends ButtonProps, VariantProps<typeof actionButtonVariants> {}

const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ variant, rounded, className, ...props }, forwardedRef) => (
    <Button {...props} ref={forwardedRef} className={cn(actionButtonVariants({ variant, rounded, className }))} />
  ),
);

ActionButton.displayName = "ActionButton";

export default ActionButton;
export { ActionButton };
export type { ActionButtonProps };
